module.exports = window.__clic_libs["jquery/dist/jquery.slim.js"];